'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const AddIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="AddIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_239_41570)">
          <path
            d="M1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12Z"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M12 6V18" stroke={sx?.color || '#3D517B'} strokeLinecap="round" strokeLinejoin="round" />
          <path d="M18 12H6" stroke={sx?.color || '#3D517B'} strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    </SvgIcon>
  )
}

AddIcon.propTypes = {
  sx: PropTypes.object
}
